import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AboutPage from './pages/About.jsx';
import ContactPage from './pages/Contact.jsx';
import DataCenterConduit from './pages/DataCenterConduit.jsx';
import HomePage from './pages/Home.jsx';
import IndustriesPage from './pages/Industries.jsx';
import IndustrialPage from './pages/Industrial.jsx';
import OilGasPage from './pages/OilGas.jsx';
import DataCentersPage from './pages/DataCenters.jsx';
import Navigation from './components/Navigation.jsx';
import Footer from './components/Footer.jsx';

const defaultDescription = 'MachineX America: CNC machining, injection molding, castings, sheet metal and assemblies, built to print and delivered duty-paid.';
const metadata = {
  '/': ['MachineX America – Home', defaultDescription],
  '/about': ['MachineX America – About', defaultDescription],
  '/industries': ['MachineX America – Industries', defaultDescription],
  '/oil-gas': ['MachineX America – Oil and Gas', defaultDescription],
  '/data-centers': ['MachineX America – Data Centers', defaultDescription],
  '/data-center-conduit': ['MachineX America – Data Center Conduit', 'HDPE and PVC conduit, duct bank spacers, couplers, terminations and assembled systems for data centers, built to your drawings and delivered on your build sequence.'],
  '/industrial': ['MachineX America – Industrial and Process Equipment', defaultDescription],
  '/contact': ['MachineX America – Contact', defaultDescription],
};

const normalizedPath = (pathname) => pathname.replace(/\.html$/, '').replace(/\/$/, '') || '/';

function PageEffects() {
  const location = useLocation();

  useEffect(() => {
    const [title, description] = metadata[normalizedPath(location.pathname)] || metadata['/'];
    document.title = title;
    let descriptionMeta = document.querySelector('meta[name="description"]');
    if (!descriptionMeta) {
      descriptionMeta = document.createElement('meta');
      descriptionMeta.name = 'description';
      document.head.appendChild(descriptionMeta);
    }
    descriptionMeta.content = description;
  }, [location.pathname]);

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }
    const targetId = decodeURIComponent(location.hash.slice(1));
    requestAnimationFrame(() => document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' }));
  }, [location.pathname, location.hash]);

  return null;
}

function RouteSet() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/index.html" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/about.html" element={<AboutPage />} />
      <Route path="/industries" element={<IndustriesPage />} />
      <Route path="/industries.html" element={<IndustriesPage />} />
      <Route path="/oil-gas" element={<OilGasPage />} />
      <Route path="/oil-gas.html" element={<OilGasPage />} />
      <Route path="/data-centers" element={<DataCentersPage />} />
      <Route path="/data-centers.html" element={<DataCentersPage />} />
      <Route path="/data-center-conduit" element={<DataCenterConduit />} />
      <Route path="/data-center-conduit.html" element={<DataCenterConduit />} />
      <Route path="/industrial" element={<IndustrialPage />} />
      <Route path="/industrial.html" element={<IndustrialPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/contact.html" element={<ContactPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  const location = useLocation();
  return (
    <div className="page">
      <a href="#main-content" className="mx-skip-link">Skip to main content</a>
      <Navigation key={location.pathname} />
      <main id="main-content">
        <PageEffects />
        <RouteSet />
      </main>
      <Footer />
    </div>
  );
}
